import { h as __h } from "preact";
/** @import { ButtonHTMLAttributes } from "preact"; */

import html from "~/util/html.js";
import Loader from "./Loader.js";
import button from "~/style/button.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Button.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Button.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {"primary" | "secondary" | "tertiary"} [level ="secondary"] Default is `"secondary"`
 * @property {"neutral" | "positive" | "negative" | "warning" | "primary"} [kind ="neutral"] .
 *   Default is `"neutral"`
 * @property {"small" | "base" | "large"} [size ="base"] Default is `"base"`
 * @property {boolean} [loading]
 * @property {string} [popovertarget]
 * @property {(el: HTMLButtonElement) => void} [innerRef]
 */

/** @param {Props & ButtonHTMLAttributes<HTMLButtonElement> & Record<`data-${string}`, unknown>} props */
export default function Button(props) {
  const {
    level,
    kind = "neutral",
    size = "base",
    loading,
    disabled,
    type = "button",
    children,
    innerRef: ref,
    ...rest
  } = props;
  return __h("button", {
    "class": css.wrapper + " " + button.button,
    "data-level": level,
    "data-kind": kind,
    "data-size": size,
    type: type,
    disabled: disabled || loading,
    ref: ref,
    ...rest
  }, __h("span", {
    "class": css.layer + " " + css.contents
  }, children), loading ? __h("span", {
    "class": css.layer + " " + css.loader
  }, __h(Loader, {})) : null);
}